import { SxProps, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

export const PageTitle = ({ children, sx }: PropsWithChildren<{ sx?: SxProps }>) => (
  <Typography
    variant="h1"
    sx={{
      marginTop: "0px",
      marginBottom: "10px",
      fontFamily: "h1.fontFamily",
      color: "secondary.main",
      fontWeight: 700,
      textTransform: "uppercase",
      fontSize: { xs: "1.75rem", md: "2.5rem" },
      ...sx,
    }}
  >
    {children}
  </Typography>
);
